// @ts-nocheck
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validator,
} from '@angular/forms';
import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { minusIcon } from '../../icon/minus/minus';
import { plusIcon } from '../../icon/plus/plus';
import { UIKitIconRegistry } from '../../icon/icon.registry';

@Component({
  selector: 'lib-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true,
    },
  ],
  exportAs: 'libInputNumber',
})
export class InputNumberComponent implements ControlValueAccessor {
  @ViewChild('input', { static: true }) input: ElementRef<HTMLInputElement>;

  @Output() update: EventEmitter<any> = new EventEmitter();

  @Output() event: EventEmitter<FocusEvent | KeyboardEvent | Event> = new EventEmitter();

  @Input() theme: 'primary' | 'warn';

  @Input() label: string;

  @Input() prefix = '';

  @Input() suffix = '';

  @Input() min: number;

  @Input() max: number;

  @Input() badge: string;

  @Input() step = 1;

  get class(): string {
    return `lib-input-number${this.theme ? `-${this.theme}` : ''}`;
  }

  @Input()
  set value(value: string | number) {
    this.writeValue(value);
  }

  get value(): string | number {
    const value = +this.data;
    return isNaN(value)
      ? 0
      : value;
  }

  get valueDisplay(): string {
    const value = this.value;
    return `${this.prefix}${value}${this.suffix}`;
  }

  get disableMin(): boolean {
    const value = this.value;
    const min = +this.min;
    return value <= min;
  }

  get disableMax(): boolean {
    const value = this.value;
    const max = +this.max;
    return value >= max;
  }

  data: any;

  constructor(
    private renderer: Renderer2,
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([plusIcon, minusIcon]);
  }

  writeValue(obj: any): void {
    this.data = obj;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState(isDisabled: boolean) {
    if (this.input?.nativeElement) {
      this.renderer.setProperty(this.input?.nativeElement, 'disabled', isDisabled);
    }
  }

  onChange(event: Event, value?: number) {
    if (!event && value !== undefined) {
      this.data = value;
    } else {
      const inputElement: HTMLInputElement = event?.target as HTMLInputElement;
      this.data = inputElement?.value;
    }
    this.propagateChange(this.data);
    this.update.emit(this.data);
  }

  validate(control: AbstractControl): { [key: string]: any } | null {
    // return control.errors;
    return null;
  }

  add(event: MouseEvent | TouchEvent): void {
    event.preventDefault();

    const value = +this.value;
    const step = +this.step;
    const max = +this.max;
    const newValue = value + step;
    if (newValue <= max) {
      this.onChange(null, newValue);
    }
  }

  subtract(event: MouseEvent | TouchEvent): void {
    event.preventDefault();

    const value = +this.value;
    const step = +this.step;
    const min = +this.min;
    const newValue = value - step;
    if (newValue >= min) {
      this.onChange(null, newValue);
    }
  }

  private propagateChange = (_: any) => { };
}
